import React from 'react';
import PropTypes from 'prop-types';

// Lightweight, memoized, and well-typed Input component for large tables
const FastInput = React.memo(
  React.forwardRef(
    (
      {
        value,
        onChange,
        type = 'text',
        name,
        placeholder,
        disabled = false,
        className = '',
        style = {},
        ...rest
      },
      ref,
    ) => {
      return (
        <input
          ref={ref}
          value={value ?? ''}
          onChange={onChange}
          type={type}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
          style={style}
          autoComplete="off"
          {...rest}
        />
      );
    },
  ),
);

FastInput.displayName = 'FastInput';

FastInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default FastInput;
